import { Controller } from "stimulus"

// data attribute: affiliate-signup-notifications--index
export default class extends Controller {
  connect() {
    // console.log("AffiliateSignupNotificationsIndexController connected");
  }
}